import posthog from "posthog-js";
import { axiosBasic, getUserInfo } from "../../../api/axios";
import { config } from "../../../api/endPoints";
import { actionTypes } from "./employmentTypeActionTypes";
import { UPDATE_PAGING } from "../../common/pagination/paginationActionTypes";
import { Common } from "../../../utils";

const { EmploymentType } = config.REST_API;

const getAll = (items) => ({ type: actionTypes.ET_SHOW_LIST, payload: items });
const softDelete = (item) => ({ type: actionTypes.ET_DELETE_SOFT, payload: item });

export const EmploymentTypeListing = (options, currentPage) => {
  const take = options.take ?? options.limit ?? 20;
  const newUrl =
    EmploymentType.Get +
    options.start +
    "/" +
    options.page +
    "/" +
    take;
  return (dispatch) => {
    const userId = getUserInfo()?.selfUserId ?? null;
    const userInput = { start: options.start, page: options.page, take, currentPage };
    dispatch({ type: actionTypes.ET_LOADING_START });
    axiosBasic
      .get(newUrl)
      .then((response) => {
        const baseModel = response.data;
        const success = baseModel.success;
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("EmploymentTypeListing", {
            type: success ? "info" : "exception",
            userId,
            success,
            userInput,
            reason: success ? undefined : baseModel.message,
          });
        }
        if (success) {
          dispatch({
            type: UPDATE_PAGING,
            payload: { data: { total: baseModel.total, currentPage } },
          });
          dispatch(getAll(baseModel.data));
        } else {
          Common.showErrorMessage(baseModel.message);
        }
      })
      .catch((error) => {
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("EmploymentTypeListing", {
            type: "exception",
            userId,
            success: false,
            userInput,
            reason: error?.response?.data?.message ?? error?.message ?? "Request failed",
          });
        }
        Common.showErrorMessage("Something went wrong");
        console.log(error);
      });
  };
};

export const saveEmploymentType = (model) => {
  const obj = {
    Name: model.name.trim(),
    Notes: (model.notes || "").trim(),
  };
  return (dispatch) => {
    const userId = getUserInfo()?.selfUserId ?? null;
    const userInput = { hasName: !!(model?.name?.trim()), hasNotes: !!(model?.notes?.trim()) };
    dispatch({ type: actionTypes.ET_LOADING_START });
    return axiosBasic
      .post(EmploymentType.Create, obj)
      .then((response) => {
        const res = response.data;
        const success = res.success;
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("saveEmploymentType", {
            type: success ? "info" : "exception",
            userId,
            success,
            userInput,
            reason: success ? undefined : res.message,
          });
        }
        if (success) {
          dispatch({ type: actionTypes.ET_ADD_SUCCESS, payload: res.data });
        }
        dispatch({ type: actionTypes.ET_LOADING_STOP });
        return res;
      })
      .catch((error) => {
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("saveEmploymentType", {
            type: "exception",
            userId,
            success: false,
            userInput,
            reason: error?.response?.data?.message ?? error?.message ?? "Request failed",
          });
        }
        dispatch({ type: actionTypes.ET_LOADING_STOP });
        return error;
      });
  };
};

const toPatchBody = (item) => ({
  Id: item.id ?? item.Id,
  Name: item.name ?? item.Name,
  Notes: item.notes ?? item.Notes ?? "",
  IsActive: item.isActive !== undefined ? item.isActive : item.IsActive !== false,
});

export const patchEmploymentType = (item) => {
  const obj = toPatchBody(item);
  return (dispatch) => {
    const userId = getUserInfo()?.selfUserId ?? null;
    const userInput = { id: obj.Id, hasName: !!obj.Name, hasNotes: !!obj.Notes };
    dispatch({ type: actionTypes.ET_LOADING_START });
    return axiosBasic
      .patch(EmploymentType.Patch, obj)
      .then((response) => {
        const res = response.data;
        const success = res.success;
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("patchEmploymentType", {
            type: success ? "info" : "exception",
            userId,
            success,
            userInput,
            reason: success ? undefined : res.message,
          });
        }
        if (success) {
          dispatch({ type: actionTypes.ET_UPDATE_SUCCESS, payload: res.data });
        }
        dispatch({ type: actionTypes.ET_LOADING_STOP });
        return res;
      })
      .catch((error) => {
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("patchEmploymentType", {
            type: "exception",
            userId,
            success: false,
            userInput,
            reason: error?.response?.data?.message ?? error?.message ?? "Request failed",
          });
        }
        dispatch({ type: actionTypes.ET_LOADING_STOP });
        return error;
      });
  };
};

export const deleteEmploymentType = (item) => {
  const id = item.id ?? item.Id;
  return (dispatch) => {
    const userId = getUserInfo()?.selfUserId ?? null;
    const userInput = { id };
    dispatch({ type: actionTypes.ET_LOADING_START });
    // employment types: DELETE .../EmploymentType/SoftDelete?id={id} (endPoints Delete ends with ?id=)
    return axiosBasic
      .delete(`${EmploymentType.Delete}${encodeURIComponent(id ?? "")}`, {
        transformRequest: [
          (data, headers) => {
            delete headers["Content-Type"];
            return data;
          },
        ],
      })
      .then((response) => {
        dispatch({ type: actionTypes.ET_LOADING_STOP });
        const baseModel = response.data;
        const success = baseModel.success;
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("deleteEmploymentType", {
            type: success ? "info" : "exception",
            userId,
            success,
            userInput,
            reason: success ? undefined : baseModel.message,
          });
        }
        if (success) {
          const list = baseModel.data ?? baseModel.Data;
          if (Array.isArray(list)) {
            dispatch(getAll(list));
          } else {
            dispatch(softDelete(item));
          }
        }
        const msg =
          typeof baseModel.message === "string"
            ? baseModel.message
            : baseModel.message?.message ?? baseModel.message?.Message;
        return { success: !!success, message: msg };
      })
      .catch((error) => {
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("deleteEmploymentType", {
            type: "exception",
            userId,
            success: false,
            userInput,
            reason: error?.response?.data?.message ?? error?.message ?? "Request failed",
          });
        }
        dispatch({ type: actionTypes.ET_LOADING_STOP });
        throw error;
      });
  };
};
